<script setup lang="ts">
import FederatedQuizResultBuilderModal from "@/components/quizzes/FederatedQuizResultBuilderModal.vue";
import { useAppStore } from "@/store/app";
import { Edit01Icon } from "@gohighlevel/ghl-icons/24/outline";
import { UIButton } from "@gohighlevel/ghl-ui";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const appStore = useAppStore();

const previewBackgroundStyle = {
  backgroundColor: "#f2f4f7",
};

const showQuizResultBuilderModal = ref(false);
const quizResultBuilderData = ref<Record<string, unknown> | null>(null);

const openQuizResultBuilderModal = () => {
  quizResultBuilderData.value = appStore.getQuizResultBuilderPayload();
  showQuizResultBuilderModal.value = true;
};

const closeQuizResultBuilderModal = () => {
  showQuizResultBuilderModal.value = false;
};
</script>

<template>
  <div class="preview-container preview-container--quizResult">
    <div class="mb-2 flex items-center justify-between text-sm font-medium text-[#344054]">
      <span>{{ t("common.preview") }}</span>
      <UIButton
        id="form_builder-btn-edit_quiz_result"
        text
        class="flex cursor-pointer items-center gap-1 text-sm font-semibold text-[#004EEB]"
        @click="openQuizResultBuilderModal"
      >
        <Edit01Icon class="mr-1 h-5 w-5" />
        <span>{{ t("quiz.editResultPage") }}</span>
      </UIButton>
    </div>
    <div
      class="bg-container relative mx-auto flex w-full items-center justify-center overflow-hidden rounded-[12px] px-8 py-8"
      :style="previewBackgroundStyle"
    >
      <div
        class="z-10 flex w-[384px] items-center justify-between gap-6 rounded-[8px] bg-white px-8 py-6"
      >
        <div class="flex flex-col gap-4">
          <div class="space-y-2">
            <div class="h-[18px] w-48 rounded-full bg-gray-100"></div>
            <div class="h-[18px] w-[72px] rounded-full bg-gray-100"></div>
          </div>
          <div class="flex items-center gap-2">
            <span class="h-[10px] w-[10px] rounded-full bg-[#F04438]"></span>
            <span class="h-[10px] w-[43px] rounded-full bg-[#EFF1F5]"></span>
            <span class="h-[10px] w-[10px] rounded-full bg-[#F79009]"></span>
            <span class="h-[10px] w-[43px] rounded-full bg-[#EFF1F5]"></span>
            <span class="h-[10px] w-[10px] rounded-full bg-[#12B76A]"></span>
            <span class="h-[10px] w-[43px] rounded-full bg-[#EFF1F5]"></span>
          </div>
        </div>
        <div class="flex flex-col items-end">
          <div class="text-[10px] font-normal leading-[15px] text-[#101828]">
            {{ t("quiz.quizResult.overallScoreLabel") }}
          </div>
          <div class="text-[36px] font-bold leading-[44px] text-[#12B76A]">88%</div>
        </div>
      </div>
    </div>
  </div>
  <FederatedQuizResultBuilderModal
    :show="showQuizResultBuilderModal"
    :data="quizResultBuilderData"
    @update:close="closeQuizResultBuilderModal"
  />
</template>

<style scoped>
.preview-container {
  height: auto;
  padding-bottom: 8px;
}

.preview-container--quizResult {
  height: 240px;
  margin-bottom: 44px !important;
}

.bg-container {
  position: relative;
  height: 100%;
}
</style>
